<script setup>
import SportLiveTvButton from '@/sport-live-tv/components/sport-live-tv-button.vue';
import SportLiveTvState from '@/sport-live-tv/components/sport-live-tv-state.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  clearable: { type: Boolean, default: false },
});

const emit = defineEmits(['clear-filters']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <SportLiveTvState :title="t('emptyTitle')" :message="t('emptyMessage')">
    <SportLiveTvButton v-if="clearable" :label="t('clearFilters')" @click="emit('clear-filters')" />
  </SportLiveTvState>
</template>
